import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { InvoicesService } from "../../../shared/services/invoices.service";

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class InvoicesComponent {

  //TODO(y.braiko@quantumobile.com): review it and remove unused code.
  public sendButtonDisabled = true;
  private error: any;
  private multiApprovalArray = [];

  constructor(private invoicesService: InvoicesService,
              public translate: TranslateService) {
  }
}



// WEBPACK FOOTER //
// /app/src/app/client/invoices/invoices/invoices.component.ts